<p-confirmDialog></p-confirmDialog>

<div class="flex justify-between py-6 border-b border-neutral-base">
  <span class="text-[18px] font-black">
    <i
      [class.pi]="true"
      [class.pi-file-check]="true"
      style="font-size: 2rem"></i>
    REVISIÓN DE SISTEMA IA
  </span>

  <div
    *ngIf="!isChief()"
    class="flex gap-3">
    <button
      type="button"
      class="text-[16px] text-primary-base underline bg-transparent border-none pr-2 font-semibold cursor-pointer"
      (click)="backPage()">
      Cancelar
    </button>
    <app-buttons
      [label]="'Sugerir subsanación'"
      [classes]="'text-primary-base border border-primary-base'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      (click)="confirm('CORRECTION')" />

    <app-buttons
      [label]="'Aprobar'"
      [classes]="'bg-primary-base text-primary-light'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      (click)="confirm('APPROVED')" />
  </div>

  <div
    *ngIf="isChief()"
    class="flex gap-3">
    <app-buttons
      [label]="'Cancelar'"
      (click)="backPage()" />
    <app-buttons
      [label]="'Subsanar'"
      [classes]="'text-primary-base border border-primary-base'"
      [disabled]="readonlyReview"
      [attr.title]="readonlyReview ? 'La revisión ya fue registrada y no puede modificarse.' : null"
      (click)="confirm('CORRECTION')" />
    <div
      [attr.title]="
        camposSeleccionados.length > 0
          ? 'Para enviar a aprobación no deben quedar campos seleccionados para subsanación.'
          : null
      ">
      <app-buttons
        [label]="'Enviar a aprobación'"
        [classes]="'bg-primary-base text-primary-light'"
        [disabled]="readonlyReview || camposSeleccionados.length > 0"
        (click)="confirm('APPROVED')" />
    </div>
  </div>
</div>

<span
  *ngIf="loadingReviewDetail"
  class="text-[16px] text-neutral-dark">
  Cargando detalle del sistema...
</span>

<span
  *ngIf="!loadingReviewDetail && reviewDetailLoadAttempted && reviewDetailLoadError"
  class="text-[16px] text-neutral-dark">
  No se ha podido cargar el detalle del sistema.
</span>

<div class="flex flex-col gap-10">
  <div
    *ngIf="systemReviewDetail as detail"
    class="flex flex-col gap-2 mt-8">
    <div class="flex flex-col gap-2 py-4">
      <span class="text-[24px] font-bold mb-2">Revisa todos los campos del sistema</span>
      <div
        *ngIf="readonlyReview"
        class="flex flex-col gap-6 text-[16px] leading-7">
        <span>
          Estás consultando una revisión previamente registrada del sistema. Desde esta vista es posible revisar los
          campos observados durante el proceso de revisión, así como consultar el histórico completo de revisiones
          realizadas por los distintos perfiles revisores.
        </span>

        <span>
          El histórico muestra los comentarios asociados a cada revisión y el estado propuesto para el sistema en cada
          fase del proceso de aprobación. La información se presenta en modo solo lectura y no permite realizar
          modificaciones sobre la revisión enviada.
        </span>
      </div>
      <div
        *ngIf="!readonlyReview && !isChief()"
        class="flex flex-col gap-6 text-[16px]">
        <span>
          Añade los comentarios que consideres necesarios sobre la revisión. Al finalizar, se aplicará una de estas dos
          opciones según tu acción:
        </span>
        <div class="flex flex-col gap-4 pl-4 text-neutral-dark">
          <span>
            &bull;
            <strong class="text-black text-[16px]">Finalizar revisión:</strong>
            el sistema pasará a la siguiente fase, donde será evaluado por el grupo de revisores correspondiente.
          </span>
          <span>
            &bull;
            <strong class="text-black text-[16px] font-semibold">Subsanar sistema:</strong>
            el solicitante deberá revisar y corregir los campos indicados antes de volver a solicitar la aprobación.
          </span>
        </div>
        <span class="text-neutral-dark text-[16px]">
          Ten en cuenta que los comentarios que escribas podrán ser visibles para otros revisores a medida que avance el
          flujo de revisión.
        </span>
      </div>
      <div
        *ngIf="!readonlyReview && isChief()"
        class="text-[16px]">
        Selecciona los campos que consideres incorrectos o que requieran revisión por parte de la persona que solicita
        el alta del sistema. Es posible que algunos campos ya aparezcan seleccionados, ya que han sido marcados
        previamente por otros revisores. Para poder enviar el sistema a aprobación, no puede haber ningún campo marcado.
      </div>
    </div>

    <div
      *ngIf="!readonlyReview"
      class="flex flex-col gap-2">
      <span class="text-xl font-bold mt-4">Comentario sobre la revisión</span>
      <span class="text-[16px] font-normal">Comentarios</span>
      <span class="text-[16px] text-neutral-dark">
        Los comentarios que escribas en este apartado se mostrarán en el turno de revisión de cada revisor.
      </span>
      <textarea
        class="w-full min-h-[160px] border border-neutral-base rounded p-3"
        [disabled]="readonlyReview"
        [(ngModel)]="reviewComment"></textarea>
    </div>

    <div
      class="flex flex-col mt-8"
      *ngIf="shouldShowReviewComments">
      <app-review-comments-block [comments]="reviewComments"></app-review-comments-block>
    </div>

    <div class="flex flex-col gap-10 mt-10">
      <div class="flex flex-col gap-6">
        <span class="text-[18px] font-bold">Datos funcionales</span>
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Nombre del sistema</span>
            <span class="text-md font-normal">{{ detail.systemName || '-' }}</span>
          </div>
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">ID del sistema</span>
            <span class="text-md font-normal">{{ systemId || '-' }}</span>
          </div>

          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Proyecto asociado</span>
            <span class="text-md font-normal">{{ detail.projectAssociated || '-' }}</span>
          </div>
          <div class="flex gap-3 items-start">
            <input
              *ngIf="!readonlyReview"
              type="checkbox"
              class="mt-1"
              [checked]="isFieldSelected('systemType')"
              [disabled]="readonlyReview"
              (change)="toggleReviewField('systemType')" />
            <div class="flex flex-col">
              <div class="flex items-start gap-2">
                <span class="text-[14px] text-neutral-dark">Tipo de sistema</span>
                <app-tooltip
                  *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('systemType')"
                  class="-mt-2"
                  [description]="previousReviewText('systemType')"
                  tipeIcon="info"></app-tooltip>
              </div>
              <span class="text-md font-normal">{{ getSystemTypeLabel(detail.systemType) }}</span>
            </div>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="!readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="isFieldSelected('functionOfSystem')"
            [disabled]="readonlyReview"
            (change)="toggleReviewField('functionOfSystem')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Funciones o tareas a las que da soporte el sistema</span>
              <app-tooltip
                *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('functionOfSystem')"
                class="-mt-2"
                [description]="previousReviewText('functionOfSystem')"
                tipeIcon="info"></app-tooltip>
            </div>
            <div class="flex flex-wrap gap-4">
              @for (func of detail.functionOfSystem || []; track func) {
                <app-pill
                  [value]="getFunctionLabel(func)"
                  [classe]="'c-pill--primary'" />
              }
            </div>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="!readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="isFieldSelected('otherFunctions')"
            [disabled]="readonlyReview"
            (change)="toggleReviewField('otherFunctions')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-[14px] text-neutral-dark">Otras funciones o tareas</span>
              <app-tooltip
                *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('otherFunctions')"
                class="-mt-2"
                [description]="previousReviewText('otherFunctions')"
                tipeIcon="info"></app-tooltip>
            </div>
            <div class="flex flex-wrap gap-4">
              @for (func of detail.otherFunctions || []; track func) {
                <app-pill
                  [value]="func"
                  [classe]="'c-pill--primary'" />
              }
            </div>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="!readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="isFieldSelected('description')"
            [disabled]="readonlyReview"
            (change)="toggleReviewField('description')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-sm text-neutral-dark">Descripción del sistema</span>
              <app-tooltip
                *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('description')"
                class="-mt-2"
                [description]="previousReviewText('description')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-md font-normal">{{ detail.description || '-' }}</span>
          </div>
        </div>
        <div class="flex gap-3 items-start">
          <input
            *ngIf="!readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="isFieldSelected('estimatedDeployDate')"
            [disabled]="readonlyReview"
            (change)="toggleReviewField('estimatedDeployDate')" />
          <div class="flex flex-col gap-2">
            <div class="flex items-start gap-2">
              <span class="text-sm text-neutral-dark">Fecha estimada de despliegue del sistema</span>
              <app-tooltip
                *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('estimatedDeployDate')"
                class="-mt-2"
                [description]="previousReviewText('estimatedDeployDate')"
                tipeIcon="info"></app-tooltip>
            </div>
            <span class="text-md font-normal">{{ detail.estimatedDeployDate || '-' }}</span>
          </div>
        </div>

        <div class="flex flex-col gap-6">
          <span class="text-xl font-bold">Datos identificativos</span>
          <div class="grid grid-cols-2 gap-4">
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('aiSystemProviderType')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('aiSystemProviderType')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Proveedor del sistema de IA</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('aiSystemProviderType')"
                    class="-mt-2"
                    [description]="previousReviewText('aiSystemProviderType')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.aiSystemProviderType || '-' }}</span>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('aiProviderName')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('aiProviderName')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Nombre del proveedor</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('aiProviderName')"
                    class="-mt-2"
                    [description]="previousReviewText('aiProviderName')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.aiProviderName || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-6">
          <span class="text-xl font-bold">Cuestiones técnicas</span>
          <div class="grid grid-cols-2 gap-4">
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('aiModelName')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('aiModelName')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Modelo de IA</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('aiModelName')"
                    class="-mt-2"
                    [description]="previousReviewText('aiModelName')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.aiModelName || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <span class="text-[18px] font-bold">Datos entrada</span>
          <div class="grid grid-cols-2 gap-4">
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('estimatedFunctionalInputVolume')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('estimatedFunctionalInputVolume')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Volumen funcional de entradas estimado</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('estimatedFunctionalInputVolume')"
                    class="-mt-2"
                    [description]="previousReviewText('estimatedFunctionalInputVolume')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.estimatedFunctionalInputVolume || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <span class="text-[18px] font-bold">Cumplimiento reglamento IA</span>
          <div class="grid grid-cols-2 gap-4">
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('administrationRole')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('administrationRole')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Papel de la administración respecto al sistema de IA</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('administrationRole')"
                    class="-mt-2"
                    [description]="previousReviewText('administrationRole')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.administrationRole || '-' }}</span>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('dataType')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('dataType')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Tipo de datos</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('dataType')"
                    class="-mt-2"
                    [description]="previousReviewText('dataType')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.dataType || '-' }}</span>
              </div>
            </div>
            <div
              class="flex gap-3 items-start"
              *ngIf="detail.otherDataType?.trim()">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('otherDataType')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('otherDataType')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Otro tipo de datos</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('otherDataType')"
                    class="-mt-2"
                    [description]="previousReviewText('otherDataType')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.otherDataType }}</span>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('explainabilityLevel')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('explainabilityLevel')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Nivel de explicabilidad del modelo</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('explainabilityLevel')"
                    class="-mt-2"
                    [description]="previousReviewText('explainabilityLevel')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal py-2">{{ detail.explainabilityLevel || '-' }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-6">
          <span class="text-[18px] font-bold">Datos económicos</span>
          <div class="grid grid-cols-2 gap-4">
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('contractingImport')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('contractingImport')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Importe contratación</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('contractingImport')"
                    class="-mt-2"
                    [description]="previousReviewText('contractingImport')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal">{{ detail.contractingImport | economicAmount }}</span>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('contractValidity')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('contractValidity')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Vigencia contratación (en meses)</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('contractValidity')"
                    class="-mt-2"
                    [description]="previousReviewText('contractValidity')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal">{{ detail.contractValidity || '-' }}</span>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('contractValidityDate')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('contractValidityDate')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Finalización vigencia contratación</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('contractValidityDate')"
                    class="-mt-2"
                    [description]="previousReviewText('contractValidityDate')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal">{{ formatContractValidityDate(detail.contractValidityDate) }}</span>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('annualAmount')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('annualAmount')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Importe anual del sistema</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('annualAmount')"
                    class="-mt-2"
                    [description]="previousReviewText('annualAmount')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal">{{ detail.annualAmount | economicAmount }}</span>
              </div>
            </div>
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('estimatedAnnualSavings')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('estimatedAnnualSavings')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Ahorro anual estimado del sistema</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('estimatedAnnualSavings')"
                    class="-mt-2"
                    [description]="previousReviewText('estimatedAnnualSavings')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span class="text-md font-normal">{{ detail.estimatedAnnualSavings | economicAmount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-6">
          <span class="text-xl font-bold">Gestión del riesgo</span>
          <div class="grid grid-cols-2 gap-3">
            <div class="flex gap-3 items-start">
              <input
                *ngIf="!readonlyReview"
                type="checkbox"
                class="mt-1"
                [checked]="isFieldSelected('systemClassification')"
                [disabled]="readonlyReview"
                (change)="toggleReviewField('systemClassification')" />
              <div class="flex flex-col">
                <div class="flex items-start gap-2">
                  <span class="text-sm text-neutral-dark">Clasificación del sistema</span>
                  <app-tooltip
                    *ngIf="shouldShowPreviousReviewIndicators() && hasPreviousReview('systemClassification')"
                    class="-mt-2"
                    [description]="previousReviewText('systemClassification')"
                    tipeIcon="info"></app-tooltip>
                </div>
                <span
                  class="text-md font-semibold"
                  [ngClass]="detail.systemClassification | riskLevelClass">
                  {{ getRiskLevelLabel(detail.systemClassification) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-6">
          <desy-collapsible>
            <span class="text-xl font-bold">Proyectos relacionados</span>
            <desy-content>
              <div class="flex flex-col flex-1">
                @for (card of detail.infoCard || []; track card.id) {
                  <app-project-card
                    [projectName]="card.projectName || '-'"
                    [state]="card.state || '-'"
                    [buttons]="card.buttons || []"
                    [creationUser]="card.creationUser || '-'"
                    [creationDate]="card.date || null"
                    [infoCard]="card.infoCard || []"
                    [description]="card.description || '-'" />
                }
              </div>
            </desy-content>
          </desy-collapsible>
        </div>
      </div>
    </div>
  </div>
</div>
